(function () {
    'use strict';

    /*global angular*/
    var app = angular.module('cccu.photoUpload.confirm', ['ui.router', 'cccu.photoUpload.services']);

    app.config(function ($stateProvider) {
        $stateProvider.state('confirm', {
            url: '/confirm',
            views: {
                'main': {
                    controller: 'ConfirmController',
                    templateUrl: 'confirm/index.html'
                }
            },
            data: {
                pageTitle: 'Confirm likeness'
            }
        });
    });

    app.controller('ConfirmController', ['$scope', '$state', '$log', 'photoUploadService', '$http', 'apiConfig', 'uiText', function ($scope, $state, $log, photoUploadService, $http, apiConfig, uiText) {

        $http.defaults.headers.common.Authorization = 'Bearer ' + apiConfig.getToken();

        $scope.submitCta = 'Finish';

        $scope.working = false;

        // link the photo data from the property in the photoUploadSerice	    
        $scope.photo = photoUploadService.photo;
        // Check to see if we've still got an image to handle
        if ($scope.photo == null) {
            $state.go('upload');
        }

        $scope.error = null;

        $scope.next = function () {
            // reset
            $scope.working = true;
            $scope.error = null;

            photoUploadService.submitPhoto().then(
                // Successful submission
                function () {
                    $state.go('success');
                }, function (response) {
                $log.info(response);
                    // if an error was returned feed that back, else return a generic message from the constant.
                    $scope.error = {
                        message: response.recoverable ? response.statusText : uiText.webApiUploadError,
                        exception: response.statusText
                    };
                }).finally(function() {
                    $scope.working = false;
            });

        };

        $scope.back = function () {
            $state.go('preview');
        };
    }]);
}());
